import { Input } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';

import { Select } from '../../reusable';

const getOptionsByCountry = (country, ccmConfig) => {
  if (country === 'USA') {
    return ccmConfig['sls.stateValues'] || [];
  }

  if (country === 'CAN') {
    return Object.keys(ccmConfig || {}).length > 0
      ? ccmConfig['sls.canadaProvinceValues'].map((province) => ({
           label: province,
           value: province,
        }))
      : [];
  }

  const emeaStateValues = ccmConfig['sls.emeaStateValues'] || {};
  if (country in emeaStateValues) {
    return emeaStateValues[country] || [];
  }

  const aplaStateValues = ccmConfig['sls.aplaStateValues'] || {};
  if (country in aplaStateValues) {
    return aplaStateValues[country] || [];
  }

  return []; // Default case
};

const Address = (props) => {
  // Use the parsed objects for lookups
  const emeaStateValues = props.ccmConfig['sls.emeaStateValues'] || {};
  const emeaStateValuesKeyList = Object.keys(emeaStateValues);
  const aplaStateValues = props.ccmConfig['sls.aplaStateValues'] || {};
  const aplaStateValuesKeyList = Object.keys(aplaStateValues);
  return (
    <section className="ncss-row">
      <header className="ncss-col-sm-12 headline-2">Address</header>
      <article className="ncss-col-sm-12 va-sm-t">
        <Input
          errorMessage={!props.disableCmpFields && props.addressErrors.address1}
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="Address 1"
          maxLength="40"
          value={props.address.address1 || ''}
          onChange={({ target: { value: address1 } }) => props.updateAddress('address1', address1)}
        />
      </article>
      <article className="ncss-col-sm-12 va-sm-t">
        <Input
          errorMessage={!props.disableCmpFields && props.addressErrors.address2}
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="Address 2"
          maxLength="40"
          value={props.address.address2 || ''}
          onChange={({ target: { value: address2 } }) => props.updateAddress('address2', address2)}
        />
      </article>
      <article className="ncss-col-sm-12 va-sm-t">
        <Input
          errorMessage={!props.disableCmpFields && props.addressErrors.address3}
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="Address 3"
          maxLength="40"
          value={props.address.address3 || ''}
          onChange={({ target: { value: address3 } }) => props.updateAddress('address3', address3)}
        />
      </article>
      <article className="ncss-col-sm-12 va-sm-t">
        <Input
          errorMessage={!props.disableCmpFields && props.addressErrors.city}
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="City"
          value={props.address.city || ''}
          onChange={({ target: { value: city } }) => props.updateAddress('city', city)}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        {props.facilityType === 'Stores' && (props.address.country === 'USA' || props.address.country === 'CAN' || emeaStateValuesKeyList.includes(props.address.country) || aplaStateValuesKeyList.includes(props.address.country))
        ? (
          <Select
            errorMessage={props.disableCmpFields ? '' : props.addressErrors.state}
            id="stateSelect"
            isDisabled={props.userIsReadOnly || props.disableCmpFields}
            label={props.address.country === 'CAN' ? 'Province' : 'State'}
            options={getOptionsByCountry(props.address.country, props.ccmConfig)}
            value={props.address.state || ''}
            zIndex={32}
            onChange={(state) => {
                if (props.address.country !== 'CAN' && emeaStateValuesKeyList.includes(props.address.country)) {
                  const stateList = emeaStateValues[props.address.country];
                  const stateCode = stateList.find((stateObj) => stateObj.label === state)?.stateCode;
                  props.updateAddress('state', `${state}#stateCode#${stateCode}`);
                } else if (props.address.country !== 'CAN' && aplaStateValuesKeyList.includes(props.address.country)) {
                  const stateList = aplaStateValues[props.address.country];
                  const stateCode = stateList.find((stateObj) => stateObj.label === state)?.stateCode;
                  props.updateAddress('state', `${state}#stateCode#${stateCode}`);
                } else {
                  props.updateAddress('state', state);
                }
            }}
          />
        )
        : (
          <Input
            errorMessage={!props.disableCmpFields && props.addressErrors.state}
            isDisabled={props.userIsReadOnly || props.disableCmpFields}
            label="State"
            value={props.address.state || ''}
            onChange={({ target: { value: state } }) => props.updateAddress('state', state)}
          />
        )}
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={!props.disableCmpFields && props.addressErrors.postalCode}
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="Postal Code"
          value={props.address.postalCode || ''}
          onChange={({ target: { value: postalCode } }) => props.updateAddress('postalCode', postalCode)}
        />
      </article>
      {props.facilityType === 'Stores' && (
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="County"
          value={props.address.county || ''}
          onChange={({ target: { value: county } }) => props.updateAddress('county', county)}
        />
      </article>
    )}
      {props.facilityType === 'Stores' && props.address.country === 'THA' && props.region === 'ASIA_PACIFIC_LATIN_AMERICA' && (
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={!props.disableCmpFields && props.addressErrors.subLocality}
          isDisabled={props.userIsReadOnly || props.disableCmpFields}
          label="Sublocality"
          value={props.address.subLocality || ''}
          onChange={({ target: { value: subLocality } }) => props.updateAddress('subLocality', subLocality)}
        />
      </article>
    )}
    </section>
  );
};

Address.propTypes = {
  address: PropTypes.shape().isRequired,
  addressErrors: PropTypes.shape().isRequired,
  ccmConfig: PropTypes.shape().isRequired,
  disableCmpFields: PropTypes.bool.isRequired,
  facilityType: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  updateAddress: PropTypes.func.isRequired,
  userIsReadOnly: PropTypes.bool.isRequired,
};

export default Address;
